import { FormattedMessage } from 'react-intl';
import { TermsDataModel } from '../../../types/info.interface';
import { FullPageModule, SectionTitle } from '../../../styles/global.styles';
import {
  EntriesContainer,
  GlossaryDescription,
  GlossaryItem,
  GlossaryTitle,
  GroupTitle,
} from './terms.styles';

export function Terms(props: TermsDataModel) {
  return (
    <FullPageModule>
      <SectionTitle>
        <FormattedMessage
          id="terms.title"
          defaultMessage="Términos y Condiciones"
        />
      </SectionTitle>
      <EntriesContainer>
        {props.main && (
          <>
            <GroupTitle>
              <FormattedMessage
                id="terms.main.groupTitle"
                defaultMessage="Información Principal"
              />
            </GroupTitle>
            {props.main.map((item, index) => (
              <GlossaryItem key={index}>
                <GlossaryTitle>
                  <FormattedMessage
                    id={`terms.main.${item.key}`}
                    defaultMessage={item.title}
                  />
                </GlossaryTitle>
                <GlossaryDescription>
                  <FormattedMessage
                    id={`terms.main.${item.key}.details`}
                    defaultMessage={item.description}
                  />
                </GlossaryDescription>
              </GlossaryItem>
            ))}
          </>
        )}
      </EntriesContainer>
    </FullPageModule>
  );
}
